"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionSubjectSearchResults = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var Shared_1 = require("../Shared");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var searchResultStyles = {
    fontSize: 'md',
    w: '100%',
    px: '4',
    py: '1',
    _hover: { bg: 'gray.100' },
};
var PermissionSubjectSearchResult = function (_a) {
    var name = _a.name, type = _a.type, onSelect = _a.onSelect, resultContainerProps = __rest(_a, ["name", "type", "onSelect"]);
    return (React.createElement(react_1.Flex, __assign({}, resultContainerProps, { as: "button", justifyContent: "space-between", alignItems: "center", sx: searchResultStyles, onClick: onSelect }),
        React.createElement(react_1.Box, null, name),
        React.createElement(react_1.Box, { opacity: 0.6 }, type)));
};
var PermissionSubjectSearchResults = function (_a) {
    var searchQuery = _a.searchQuery, onSelect = _a.onSelect;
    var _b = (0, usePermissionsModalContext_1.usePermissionsModalContext)(), _js = _b._js, useUsersAndTeamsSuggestions = _b.useUsersAndTeamsSuggestions;
    var debouncedSearchQuery = (0, Shared_1.useDebounced)(searchQuery, 500);
    var suggestions = useUsersAndTeamsSuggestions(debouncedSearchQuery).data;
    var hasSearchResults = Boolean((suggestions === null || suggestions === void 0 ? void 0 : suggestions.users.length) || (suggestions === null || suggestions === void 0 ? void 0 : suggestions.teams.length));
    if (!hasSearchResults || !searchQuery) {
        return null;
    }
    return (React.createElement(react_1.Menu
    // Chakra maps this id to #menu-list-permissions-modal-search-results
    , { 
        // Chakra maps this id to #menu-list-permissions-modal-search-results
        id: "permissions-modal-search-results", isOpen: hasSearchResults },
        React.createElement(react_1.MenuList, { maxHeight: "50vh", overflowY: "auto", boxShadow: "md" }, suggestions === null || suggestions === void 0 ? void 0 :
            suggestions.users.map(function (suggestion) { return (React.createElement(PermissionSubjectSearchResult, { key: "user-".concat(suggestion.userid), onSelect: function () {
                    return onSelect({
                        type: 'user',
                        id: suggestion.userid,
                        name: suggestion.username,
                    });
                }, name: suggestion.username, type: _js('User'), "data-userid": suggestion.userid })); }), suggestions === null || suggestions === void 0 ? void 0 :
            suggestions.teams.map(function (suggestion) { return (React.createElement(PermissionSubjectSearchResult, { key: "team-".concat(suggestion.teamid), onSelect: function () {
                    return onSelect({
                        type: 'team',
                        id: suggestion.teamid,
                        name: suggestion.name,
                    });
                }, name: suggestion.name, type: _js('Team'), "data-teamid": suggestion.teamid })); }))));
};
exports.PermissionSubjectSearchResults = PermissionSubjectSearchResults;
